<template>
<div class="chapter">
<div class="inner_page">
<h1 class="BookTitle">Bengal Fire</h1>
<h2 class="BookSubtitle" style="margin-top:60px;">An Inspector Prike Mystery</h2>
<p class="author" style="margin-top:60px;">Lawrence G. Blochman</p>
<p class="center" style="margin-top:80px;"><img alt="image" src="images/logo3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?2e31ff17